











import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class BuyOneGetOne extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return {
        quantity: 1,
        count: 1,
        memberScope: "All",
        cumulativeWithOtherDiscount: false
      };
    }
  })
  value!: any;
}
